import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'custom-event-polyfill'

import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import { readFile } from '@/utils'

import vuetify from './plugins/vuetify'

import './plugins/router'
import './plugins/axios'
import './plugins/machine'
import './plugins/viewport'
import './plugins/v-viewer'

import notifier from './plugins/notifier'
import store from './store'

import App from './App.vue'
import router from './router'

import i18n from './plugins/i18n'

Vue.use(VueCompositionApi)
Vue.use(notifier)

Vue.config.productionTip = false

let config = require('./config.js').default
let wlURL = 'https://whitelabel.idonia.com/'
wlURL = config.whitelabelUrl || wlURL
let started
try {
  started = parent.document.getElementById('idoniaViewerLoadedFlag') !== null
} catch (e) {
  started = false
}
init()

function getWhitelabelConfig(UIDomain, file, whitelabelConfig = {}) {
  return new Promise((resolve) => {
    readFile(wlURL + UIDomain + file, response => {
        whitelabelConfig = JSON.parse(response) || whitelabelConfig;
        resolve(whitelabelConfig);
      }
      , (e) => {
        console.error(e);
        resolve(whitelabelConfig);
      });
  }).catch(e => {
    console.error(e);
  });
}

async function init() {
  if (started) {
    return
  }
  started = true
  console.debug('Welcome to Idonia Viewer')

  const provisioningPromise = new Promise(resolve => {
    readFile('/provisioning/config.json', response => {
      const provisionedConfig = JSON.parse(response)
      wlURL = provisionedConfig.whitelabelUrl || wlURL
      resolve(provisionedConfig)
    }, resolve)
  })
  
  const [provisionedConfig] = await Promise.all([provisioningPromise])
  config = Object.assign(config, provisionedConfig)
  Vue.prototype.$config = config

  if (inIFrame()) {
    let trackingCodeTriedToSet = false
    window.addEventListener('message', async function (event) {
      if (trackingCodeTriedToSet) {
        window.removeEventListener('message', this)
        return
      }
      const data = event.data
      if (data.type !== "idonia-setup-origin") {
        return
      }
      trackingCodeTriedToSet = true
      let UIDomain = ''
      let eventHost = ''

      try {
        UIDomain = data.origin ? new URL(data.origin).hostname : "";
      } catch (e) {
        console.error("idonia-viewer: bad origin ", data.origin);
      }
      try {
        eventHost = new URL(event.origin).hostname;
      } catch (e) {
        console.error("idonia-viewer: bad event origin ", event.origin);
      }
      if (UIDomain === eventHost || (event.origin === 'null' && UIDomain !== '')) {
          const [whitelabelConfig, whitelabelConfigUI] =
            await Promise.all([
              getWhitelabelConfig(UIDomain, "/config.json"),
              getWhitelabelConfig(UIDomain, "/config_ui.json")
            ])
          const gaTrackingCode = whitelabelConfig.gaTrackingCode || config.gaTrackingCode
          var gtmCode = whitelabelConfig.gtmCode || config.gtmCode
          if (whitelabelConfig.gaTrackingCode && whitelabelConfig.gaTrackingCode !== config.gaTrackingCode && !whitelabelConfig.gtmCode) {
            gtmCode = ''
          }
          const viewerConfig = whitelabelConfigUI.viewer_config || config.viewer_config || {}
          app.$set(app.$config, 'gaTrackingCode', gaTrackingCode)
          app.$set(app.$config, 'gtmCode', gtmCode)
          app.$set(app.$config, 'viewerConfig', viewerConfig)
          app.$emit('config-updated', app.$config)
        } else {
        console.error("idonia-viewer: origin mismatch");
      }
    })
    window.parent.postMessage({ type: 'idonia-searching-origin' }, '*')
  }

  const app = new Vue({
    i18n,
    store,
    vuetify,
    router,
    render: h => h(App)
  })
  app.$mount('#app')
}

function inIFrame () {
  return window.location !== window.parent.location
}


